var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "viewBox": "0 0 200 200",
      "width": "200",
      "height": "200",
      "xmlns": "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "100",
      "fill": "#2196F3"
    }
  }), _c('path', {
    attrs: {
      "d": "M200 100c0 55.2-44.8 100-100 100V0c36.4 0 68.4 19.5 85.9 48.6C194.3 62.8 200 80.8 200 100z",
      "fill": "#1D7FCE"
    }
  }), _c('path', {
    attrs: {
      "d": "M40 86h50l12 12h58c6 0 10 4 10 10v54c0 6-4 10-10 10H40c-6 0-10-4-10-10V96c0-6 4-10 10-10z",
      "fill": "#2A3B4F"
    }
  }), _c('path', {
    attrs: {
      "d": "M40 72h42l10 14H40V72z",
      "fill": "#324B5E"
    }
  }), _c('rect', {
    attrs: {
      "x": "68",
      "y": "50",
      "width": "38",
      "height": "42",
      "rx": "4",
      "fill": "#FFF6D6"
    }
  }), _c('rect', {
    attrs: {
      "x": "82",
      "y": "42",
      "width": "38",
      "height": "42",
      "rx": "4",
      "fill": "#FFC61B"
    }
  }), _c('rect', {
    attrs: {
      "x": "90",
      "y": "52",
      "width": "22",
      "height": "4",
      "rx": "2",
      "fill": "#2A3B4F",
      "opacity": "0.22"
    }
  }), _c('rect', {
    attrs: {
      "x": "90",
      "y": "62",
      "width": "16",
      "height": "4",
      "rx": "2",
      "fill": "#2A3B4F",
      "opacity": "0.16"
    }
  }), _c('path', {
    attrs: {
      "d": "M30 102h140s-10 50-14 58c-2 4-6 6-10 6H54c-4 0-8-2-10-6-4-8-14-58-14-58z",
      "fill": "#FFC61B"
    }
  }), _c('path', {
    attrs: {
      "d": "M170 102s-10 50-14 58H100V102h70z",
      "fill": "#F4B400",
      "opacity": "0.35"
    }
  }), _c('circle', {
    attrs: {
      "cx": "78",
      "cy": "128",
      "r": "14",
      "fill": "#2A3B4F"
    }
  }), _c('circle', {
    attrs: {
      "cx": "98",
      "cy": "128",
      "r": "14",
      "fill": "#324B5E"
    }
  }), _c('circle', {
    attrs: {
      "cx": "98",
      "cy": "128",
      "r": "14",
      "fill": "none",
      "stroke": "#FFC61B",
      "stroke-width": "3"
    }
  }), _c('circle', {
    attrs: {
      "cx": "138",
      "cy": "136",
      "r": "20",
      "fill": "#2A3B4F"
    }
  }), _c('path', {
    attrs: {
      "d": "M129 136.5l7 7 13-15",
      "fill": "none",
      "stroke": "#FFC61B",
      "stroke-width": "4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }